import React, {Component} from 'react'
import './ShowCardStyles.css'

export class ShowCard extends Component {
    render() {
      return (
          <div className='card-list'>
            <div className='card'>
              <h1>{this.props.heading}</h1>
              <p>{this.props.sub}</p>
              <p>{this.props.text}</p>
              <a href={this.props.link}>
                <button>Buy Ticket</button>
              </a>
            </div>
        </div>
      )
    }
  }